// API Configuration
export const BASEURL = process.env.REACT_APP_API_URL;
export const IMAGEURL = "http://localhost:8002/uploads/images/";
export const PROMOTIONS_IMAGEURL = "http://localhost:8002/uploads/images/promotions/";
export const BANNERS_IMAGEURL = "http://localhost:8002/uploads/images/";
export const MOVIES_IMAGEURL = "http://localhost:8002/uploads/images/movies/";
export const CINEMAS_IMAGEURL = "http://localhost:8002/uploads/images/cinemas/";
export const SCREENTYPES_IMAGEURL = "http://localhost:8002/uploads/images/screentypes/";
export const CONCESSIONS_IMAGEURL = "http://localhost:8002/uploads/images/concessions/";

export const API_VERSION = "v1.0";
export const S3BASEURL = "";

// Cookie Configuration
export const COOKIE_TYPES = {
  MCHASHID: "MCHASHID"
};

// App Configuration
export const APP_CONFIG = {
  systemName: 'OTT',
  copyright: '2024 OTT Dashboard',
  systemLogo: '/src/assets/logo/logo.png',
  systemSmallLogo: '/src/assets/logo/logo.png',
  systemLogoDark: '/src/assets/logo/logo.png',
  footerLinks: [
    // { link: 'link', name: 'Pro' },
    // { link: 'link', icon: 'github' },
    // { link: 'https://ant.design', name: 'Ant Design' }
  ]
};
